import {
  createContext,
  useMemo,
  useCallback,
  useState,
  useContext,
  useEffect,
} from "react";
import { lightTheme } from "../themes/light";
import { darkTheme } from "../themes/dark";
import { ThemeProvider } from "@mui/material";
import { Box } from "@mui/system";
import { IthemeProviderProps } from "../utils";

interface IthemeContextData {
  themeName: "light" | "dark";
  toggleTheme: () => void;
}

const ThemeContext = createContext<IthemeContextData>({} as IthemeContextData);

export const useAppThemeContext = () => {
  return useContext(ThemeContext);
};

export function AppThemeProvider({ children }: IthemeProviderProps) {
  const [themeName, setThemeName] = useState<"light" | "dark">(() => {
    return (localStorage.getItem("themeName") as "light" | "dark") ?? "light";
  });

  const toggleTheme = useCallback(() => {
    setThemeName((oldThemeName) =>
      oldThemeName === "light" ? "dark" : "light"
    );
  }, []);

  // Sincroniza a classe "dark" no <html> para os utilitários dark: do Tailwind
  useEffect(() => {
    document.documentElement.classList.toggle("dark", themeName === "dark");
    localStorage.setItem("themeName", themeName);
  }, [themeName]);

  const theme = useMemo(() => {
    if (themeName === "light") {
      return lightTheme();
    }
    return darkTheme();
  }, [themeName]);

  return (
    <ThemeContext.Provider value={{ themeName, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <Box
          width="100vw"
          height="100vh"
          bgcolor={theme.palette.background.default}
        >
          {children}
        </Box>

      </ThemeProvider>
    </ThemeContext.Provider>
  );
}
